import { Clock } from 'lucide-react';
import { type ReactElement } from 'react';

import { useServerClock } from '@/hooks/useServerClock';
import { useI18n } from '@/i18n';
import { cn } from '@/lib/utils';

interface ServerClockProps {
  variant?: 'inline' | 'banner';
  className?: string;
}

export function ServerClock({ variant = 'inline', className }: ServerClockProps): ReactElement {
  const { t, formatDateTime } = useI18n();
  const now = useServerClock();

  if (variant === 'banner') {
    return (
      <div
        className={cn(
          'flex items-center gap-2 rounded-[var(--radius-md)] border border-border bg-secondary/60 px-3 py-2 text-sm',
          className,
        )}
      >
        <Clock className="h-4 w-4 shrink-0 text-primary" />
        <div className="min-w-0">
          <p className="text-xs text-muted">{t('common.serverTime')}</p>
          <p className="font-medium tabular-nums">
            {now ? formatDateTime(now) : t('common.syncing')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-1 text-xs text-muted', className)}>
      <Clock className="h-3.5 w-3.5 shrink-0" />
      <span className="tabular-nums">{now ? formatDateTime(now) : '—'}</span>
      <span>· {t('common.server')}</span>
    </div>
  );
}
